// NCS AU Shopify theme — progressive enhancements
// All interactions degrade gracefully if JS is off.

(function () {
  'use strict';

  // ---------- Mobile drawer ----------
  function initMobileDrawer() {
    const drawer = document.querySelector('[data-mobile-drawer]');
    if (!drawer) return;
    document.querySelectorAll('[data-mobile-menu-open]').forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
      });
    });
    drawer.querySelectorAll('[data-mobile-menu-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.removeAttribute('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ---------- Quantity steppers ----------
  function initQtySteppers() {
    document.querySelectorAll('[data-qty-stepper]').forEach(group => {
      const input = group.querySelector('input[type="number"]');
      const valEl = group.querySelector('[data-qty-val]');
      const minus = group.querySelector('[data-qty-minus]');
      const plus  = group.querySelector('[data-qty-plus]');
      if (!input) return;
      const sync = () => {
        if (valEl) valEl.textContent = input.value;
      };
      sync();
      if (minus) minus.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = v; sync();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', () => {
        const v = parseInt(input.value, 10) + 1;
        input.value = v; sync();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // ---------- Product variant picker ----------
  function initVariantPicker() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare-price]');
    const skuEl = document.querySelector('[data-product-sku]');
    const stockEl = document.querySelector('[data-product-stock]');
    const submitEl = form.querySelector('[type="submit"]');
    const variantsScript = document.querySelector('[data-product-variants]');
    if (!variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    function pickVariant() {
      const optionInputs = form.querySelectorAll('[data-variant-option]:checked');
      const selected = Array.from(optionInputs).map(i => i.value);
      const match = variants.find(v => {
        return v.options.every((o, i) => o === selected[i]);
      });
      if (!match) return;
      variantInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (compareEl) compareEl.innerHTML = match.compare_at_price_html || '';
      if (skuEl) skuEl.textContent = match.sku || '';
      if (submitEl) {
        submitEl.disabled = !match.available;
        submitEl.querySelector('[data-atc-label]').textContent =
          match.available ? 'Add to cart · ' + match.price_formatted : 'Sold out';
      }
      if (stockEl) stockEl.style.display = match.available ? '' : 'none';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
    form.querySelectorAll('[data-variant-option]').forEach(input => {
      input.addEventListener('change', pickVariant);
    });
  }

  // ---------- PDP tabs ----------
  function initPDPTabs() {
    const nav = document.querySelector('[data-pdp-tabs]');
    if (!nav) return;
    const tabs = nav.querySelectorAll('[data-pdp-tab]');
    const panels = document.querySelectorAll('[data-pdp-panel]');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        const id = tab.dataset.pdpTab;
        panels.forEach(p => p.style.display = p.dataset.pdpPanel === id ? '' : 'none');
      });
    });
  }

  // ---------- Collection mobile filter toggle ----------
  function initCollectionFilters() {
    const toggle = document.querySelector('[data-filters-toggle]');
    const panel = document.querySelector('[data-filters-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', () => panel.classList.toggle('is-open'));
  }

  // ---------- Cart drawer ----------
  function initCartCount() {
    const update = () => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
        })
        .catch(() => {});
    };
    update();
    document.addEventListener('cart:updated', update);
  }

  // ---------- Ajax add-to-cart ----------
  function initAjaxCart() {
    document.querySelectorAll('[data-ajax-cart-form]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const fd = new FormData(form);
        const btn = form.querySelector('[type="submit"]');
        const original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
        fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(r => r.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (btn) {
              btn.innerHTML = 'Added ✓';
              setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 1500);
            }
          })
          .catch(() => {
            if (btn) { btn.innerHTML = original; btn.disabled = false; }
          });
      });
    });
  }

  // ---------- Smooth init ----------
  function init() {
    initMobileDrawer();
    initQtySteppers();
    initVariantPicker();
    initPDPTabs();
    initCollectionFilters();
    initCartCount();
    initAjaxCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
